package com.wintermar.inspection.core.ui.widget

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.button.IconButton
import com.wintermar.inspection.core.ui.component.button.iconButtonContent
import com.wintermar.inspection.core.ui.component.image.util.FileGroupTypes
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.util.modifier.dashBorder
import com.wintermar.inspection.core.ui.util.modifier.fileDropTarget
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.click_to_upload
import inspection.composeapp.generated.resources.drag_photo
import inspection.composeapp.generated.resources.empty_upload_message
import inspection.composeapp.generated.resources.ic_upload
import io.github.vinceglb.filekit.PlatformFile
import org.jetbrains.compose.resources.stringResource

@Composable
fun AttachFileButton(
    enabled: Boolean = true,
    isError: Boolean,
    modifier: Modifier = Modifier,
    onFileDrop: (List<PlatformFile>) -> Unit = {},
    onClick: () -> Unit
) {
    val color = LocalAppTheme.current.color
    val dimension = LocalAppTheme.current.dimension
    Column(
        verticalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space1
        )
    ) {
        Column(
            modifier = modifier
                .fileDropTarget(
                    acceptableExtensions = FileGroupTypes.IMAGES_AND_DOCUMENTS.extensions,
                    onDrop = onFileDrop
                )
                .dashBorder(
                    radius = dimension.radius.md,
                    color = when {
                        isError -> color.border.error
                        enabled -> color.border.info
                        else -> color.border.default
                    },
                )
                .clickable(enabled = enabled, onClick = onClick)
                .padding(dimension.spacing.space4),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(
                space = dimension.spacing.space4,
                alignment = Alignment.CenterVertically
            )
        ) {
            IconButton(
                icon = Res.drawable.ic_upload,
                enabled = enabled,
                contentValue = iconButtonContent().copy(
                    radius = dimension.radius.full,
                    padding = dimension.spacing.space4,
                    height = dimension.size.size10,
                    width = dimension.size.size10
                ),
                backgroundColor = color.surface.brand.primarySubtle.default,
                tint = color.icon.brand,
                modifier = Modifier.size(
                    dimension.size.size10
                ),
                onClick = onClick
            )

            Row {
                TextBodySmall(
                    text = stringResource(Res.string.drag_photo),
                    color = { if (enabled) it.subtle else it.disabled })

                TextBodySmall(
                    text = stringResource(Res.string.click_to_upload),
                    color = { if (enabled) it.info.default else it.disabled })
            }
        }

        AnimatedVisibility(visible = isError, enter = fadeIn(), exit = fadeOut()) {
            TextBodySmall(
                text = stringResource(Res.string.empty_upload_message),
                color = { it.error.default }
            )
        }
    }
}
